"use strict";

class SalesApplicationAddSaleBuyerParticularController {

    constructor($scope, $sce, $parse, $timeout, SSHttpService, SSEoiService, SSUserService, SSConfigService, SSUtilService, SSAlertService, SSAwsService, SSSaleDiscountsService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;
        self.sce = $sce;
        self.$timeout = $timeout;
        self.SSHttpService = SSHttpService;
        self.SSEoiService = SSEoiService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSAwsService = SSAwsService;
        self.SSSaleDiscountsService = SSSaleDiscountsService;

        self.units = [];
        self.buyers = [];
        self.individualBuyer = [];
        self.new_buyer = {};
        self.is_add_buyer = false;
        self.buyerErrors = {};
        self.buyerIndividualErrors = {};

        self.SSEoiService.genders = self.SSConfigService.getGenders();
        self.SSEoiService.countries = self.SSConfigService.getCountries();
        self.SSEoiService.nationalities = self.SSConfigService.getNationalities();
        self.SSEoiService.maritalStatuses = self.SSConfigService.getMaritalStatuses();
        self.SSEoiService.buyer_relationships = self.SSConfigService.getBuyerRelationships();
        self.SSEoiService.buyer_relationships_ec = self.SSConfigService.getBuyerRelationships(true);
        self.SSEoiService.buyer_relationships.push({
            id: 9999,
            name: 'Others'
        });
        self.SSEoiService.races = self.SSConfigService.getRaces();
        self.SSEoiService.races.push({
            id: 9999,
            name: 'Others'
        });

        self.nric_type = 'NRIC';
        self.passport_type = 'Passport No';

        self.email_type = 'email_contact';
        self.phone_type = 'phone1_contact';

        self.email_type_buyer = 'email';
        self.phone_type_buyer = 'phone';

        self.SINGAPORE_SELECTOR_ID = 702;
        self.primary_address_type = "primary_address";
        self.mailing_address_type = "mailing_address";

        self.init();
    }

    init(){
        const self = this;

        self.showEdit = false;
    }


    getBuyers(){
        const self = this;

        let url = `sec/buyers`;

        self.SSHttpService.getAPIRequest(url).then(function (response) {

           if (response instanceof Error) {
               console.log(response.message + "\n" + JSON.stringify(response.data));;
           }
           else if(response.success){

               _.each(response.data.buyers, function (buyer) {
                if(buyer.individual != null){
                    self.individualBuyer = buyer;
                }
                self.buyers.push(buyer);
            });
           }
       });
    }

    editBuyer(buyer, index, first_buyer_obj, is_add_buyer) {
        const self = this;

        self.buyerErrors = {};
        self.editIndividualObj = {};
        self.is_add_buyer = is_add_buyer ? is_add_buyer : false;

        //Prepare edit buyer object
        self.editBuyerObj = self.prepareEditBuyerObj(buyer);

        // Check if buyer 1 has primary address
        self.editBuyerObj.address_same_first_buyer = false;
        self.editBuyerObj.has_buyer1_primary_address =
            !!(self.SSEoiService.buyers
                && self.SSEoiService.buyers[0]
                && self.SSEoiService.buyers[0].primary_address);

        //Prepare individual obj if buyer is corporate buyer
        if (self.editBuyerObj.hasOwnProperty("type") && self.editBuyerObj.type == SHOWSUITE.BUYER_TYPE_COMPANY) {
            self.editIndividualObj = self.prepareEditBuyerObj(self.SSEoiService.buyers[1]);
        }

        self.SSEoiService.buyerParticularError = false;
        self.$timeout(function () {
            $("select.dashboard-select").niceSelect('update');
            jQuery('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
            self.maskPhoneNumber(self, 'particularsCtrl.', 'personPurchaseDetails');
        });

        self.showEdit = true;
        self.SSEoiService.hideFooterButtons = true;
        self.editingIndex = index == undefined ? 0 : index;

        if (self.editingIndex > 0) {
            self.first_buyer = false;
            self.first_buyer_obj = first_buyer_obj;
        } else {
            self.first_buyer = true;
        }
    }

    updatePhoneMask() {
        const self = this;

        self.$timeout(function() { 
            self.maskPhoneNumber(self, 'particularsCtrl.', 'personPurchaseDetails');
        });
    }

    renderHtml(content) {
        const self = this;

        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.sce.trustAsHtml(window.ssSanitizeHtml(content));
    }

    prepareEditBuyerObj(buyer) {
        const self = this;

        if (buyer != undefined) {
            if (buyer.hasOwnProperty("individual") && buyer.individual != null) {
                buyer["individual_title"] = buyer.individual.title;
                buyer["individual_legal_name"] = buyer.individual.legal_name;
                buyer["individual_first_name"] = buyer.individual.first_name;
                buyer["individual_last_name"] = buyer.individual.last_name;
                buyer["individual_display_name"] = buyer.individual.display_name;
                buyer["individual_gender"] = buyer.individual.gender;
                buyer["individual_marital_status"] = buyer.individual.marital_status;
                buyer["individual_dob"] = self.SSUtilService.formatUtcToLocalDate(buyer.individual.dob);
                buyer["individual_identity_type"] = buyer.individual.identity_type;
                buyer["individual_nationality"] = buyer.individual.nationality;
                buyer["individual_country_of_origin"] = buyer.individual.country_of_origin;
                buyer["individual_national_id"] = buyer.individual.national_id;
                buyer["individual_passport_no"] = buyer.individual.passport_no;
                buyer["individual_industry"] = buyer.individual.industry;
                if (buyer.individual.occupation && buyer.individual.industry) {
                    let industry_occupation = self.SSEoiService.industry_occupation[buyer.individual.industry];

                    if (industry_occupation) {
                        let occupation_obj = industry_occupation[buyer.individual.occupation];
                        if (occupation_obj) {
                            buyer["individual_occupation"] = buyer.individual.occupation;
                        } else {
                            buyer["individual_occupation"] = 'OTHERS';
                            buyer["individual_occupation_other"] = buyer.individual.occupation;
                        }
                    }                    
                }
                if (buyer.individual.race) {
                    // WEB-4518 main name + aliases, so a stored variant binds to the master-list race
                    const raceName = self.SSConfigService.resolveRaceName(buyer.individual.race, self.SSEoiService.races, { log: false });
                    if (raceName) {
                        buyer["individual_race"] = raceName;
                    } else {
                        buyer["individual_race"] = 'Others';
                        buyer["individual_race_other"] = buyer.individual.race;
                    }
                }
                if (buyer.individual.relationship) {
                    if (self.SSEoiService.relationships.find(x => x.name == buyer.individual.relationship)) {
                        buyer["individual_relationship"] = buyer.individual.relationship;
                    } else {
                        buyer["individual_relationship"] = 'Others';
                        buyer["individual_relationship_other"] = buyer.individual.relationship;
                    }
                }
            }

            if (buyer.hasOwnProperty("company") && buyer.company != null) {
                buyer["company_name"] = buyer.company.name;
                buyer["company_reg_no"] = buyer.company.reg_no;
            }

            if (buyer.hasOwnProperty("primary_address") && buyer.primary_address != null) {
                buyer["primary_address_line1"] = buyer.primary_address.line1;
                buyer["primary_address_line2"] = buyer.primary_address.line2;
                buyer["primary_address_postcode"] = buyer.primary_address.postcode;
                buyer["primary_address_unit_no"] = buyer.primary_address.unit_no;
                buyer["primary_address_city"] = buyer.primary_address.city;
                buyer["primary_address_district"] = buyer.primary_address.district;
                buyer["primary_address_province"] = buyer.primary_address.province;
                buyer["primary_address_country"] = buyer.primary_address.country;

                if (buyer["primary_address_country"] === self.SINGAPORE_SELECTOR_ID) {
                    if (buyer["primary_address_unit_no"] !== null && buyer["primary_address_unit_no"] !== "") {
                        let full_unit_no = buyer["primary_address_unit_no"];
                        full_unit_no = full_unit_no.substring(1);
                        full_unit_no = full_unit_no.split("-");
                        buyer["primary_address_unit_no_floor"] = full_unit_no[0];
                        buyer["primary_address_unit_no_unit"] = full_unit_no[1]; 
                    }
                }
            } else {
                buyer["primary_address_country"] = self.SINGAPORE_SELECTOR_ID;
            }

            if (buyer.hasOwnProperty("mailing_address") && buyer.mailing_address != null) {
                buyer["mailing_address_line1"] = buyer.mailing_address.line1;
                buyer["mailing_address_line2"] = buyer.mailing_address.line2;
                buyer["mailing_address_postcode"] = buyer.mailing_address.postcode;
                buyer["mailing_address_unit_no"] = buyer.mailing_address.unit_no;
                buyer["mailing_address_city"] = buyer.mailing_address.city;
                buyer["mailing_address_district"] = buyer.mailing_address.district;
                buyer["mailing_address_province"] = buyer.mailing_address.province;
                buyer["mailing_address_country"] = buyer.mailing_address.country;

                if (buyer["mailing_address_country"] === self.SINGAPORE_SELECTOR_ID) {
                    if (buyer["mailing_address_unit_no"] !== null && buyer["mailing_address_unit_no"] !== "") {
                        let full_unit_no = buyer["mailing_address_unit_no"];
                        full_unit_no = full_unit_no.substring(1);
                        full_unit_no = full_unit_no.split("-");
                        buyer["mailing_address_unit_no_floor"] = full_unit_no[0];
                        buyer["mailing_address_unit_no_unit"] = full_unit_no[1]; 
                    }
                }
            } else {
                buyer["mailing_address_country"] = self.SINGAPORE_SELECTOR_ID;
            }

            if (buyer.hasOwnProperty("email_contact") && buyer.email_contact != null) {
                buyer["email_contact_value"] = buyer.email_contact.value;
            }
            
            if (buyer.hasOwnProperty("phone1_contact") && buyer.phone1_contact != null) {
                buyer["phone1_contact_value"] = buyer.phone1_contact.value;
            }

            if (buyer.hasOwnProperty("phone2_contact") && buyer.phone2_contact != null) {
                buyer["phone2_contact_value"] = buyer.phone2_contact.value;
            }

            if (buyer.individual_race) {
                // WEB-4518 main name + aliases, so a stored variant binds to the master-list race
                const raceName = self.SSConfigService.resolveRaceName(buyer.individual_race, self.SSEoiService.races, { log: false });
                if (raceName) {
                    buyer["individual_race"] = raceName;
                } else {
                    buyer["individual_race_other"] = buyer.individual_race;
                    buyer["individual_race"] = 'Others';
                }
            }
            if (buyer.individual_relationship) {
                if (!self.SSEoiService.relationships.find(x => x.name == buyer.individual_relationship)) {
                    buyer["individual_relationship_other"] = buyer.individual_relationship;
                    buyer["individual_relationship"] = 'Others';
                }
            }
        } else {
            buyer = {};
            buyer["primary_address_country"] = self.SINGAPORE_SELECTOR_ID;
            buyer["mailing_address_country"] = self.SINGAPORE_SELECTOR_ID;
        }

        return buyer;
    }

    cancelEdit() {
        const self = this;
        self.showEdit = false;
        self.SSEoiService.hideFooterButtons = false;
    }

    returnDoBBackToDisplayMode() {
        const self = this;

        if (self.editBuyerObj.individual_dob) {
            self.editBuyerObj.individual_dob = self.SSUtilService.formatUtcToLocalDate(self.editBuyerObj.individual_dob);
        }
    }

    saveParticular() {
        const self = this;

        self.buyerErrors = {};
        self.buyerIndividualErrors = {};

        if (self.validateParticular()) {
            let params = self.editBuyerObj;
            params["include"] = "individual, company, primary_address, mailing_address, email_contact, phone1_contact, phone2_contact, documents";

            if (params['individual_identity_type'] == SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                params['individual_national_id'] = null;
            } else {
                params['individual_passport_no'] = null;
            }

            if (self.editBuyerObj.address_same_first_buyer) {
                params["primary_address_line1"] = self.first_buyer_obj.primary_address_line1;
                params["primary_address_line2"] = self.first_buyer_obj.primary_address_line2;
                params["primary_address_postcode"] = self.first_buyer_obj.primary_address_postcode;
                params["primary_address_unit_no"] = self.first_buyer_obj.primary_address_unit_no;
                params["primary_address_city"] = self.first_buyer_obj.primary_address_city;
                params["primary_address_district"] = self.first_buyer_obj.primary_address_district;
                params["primary_address_province"] = self.first_buyer_obj.primary_address_province;
                params["primary_address_country"] = self.first_buyer_obj.primary_address_country;

                if (self.first_buyer_obj.mailing_address) {
                    params["mailing_address_line1"] = self.first_buyer_obj.mailing_address_line1;
                    params["mailing_address_line2"] = self.first_buyer_obj.mailing_address_line2;
                    params["mailing_address_postcode"] = self.first_buyer_obj.mailing_address_postcode;
                    params["mailing_address_unit_no"] = self.first_buyer_obj.mailing_address_unit_no;
                    params["mailing_address_city"] = self.first_buyer_obj.mailing_address_city;
                    params["mailing_address_district"] = self.first_buyer_obj.mailing_address_district;
                    params["mailing_address_province"] = self.first_buyer_obj.mailing_address_province;
                    params["mailing_address_country"] = self.first_buyer_obj.mailing_address_country;
                }                
            } else {
                if (self.editBuyerObj.primary_address_country === self.SINGAPORE_SELECTOR_ID) {
                    if (self.editBuyerObj.primary_address_unit_no_unit !== undefined 
                        && self.editBuyerObj.primary_address_unit_no_unit !== null 
                        && self.editBuyerObj.primary_address_unit_no_unit !== "") {
                        params["primary_address_unit_no"] = self.SSEoiService.formatSGAddressUnitFloor(self.editBuyerObj.primary_address_unit_no_unit, self.editBuyerObj.primary_address_unit_no_floor);
                    }
                }
            }

            if (self.editBuyerObj.mailing_address_country === self.SINGAPORE_SELECTOR_ID) {
                if (self.editBuyerObj.mailing_address_unit_no_unit !== undefined 
                    && self.editBuyerObj.mailing_address_unit_no_unit !== null 
                    && self.editBuyerObj.mailing_address_unit_no_unit !== "") {
                    params["mailing_address_unit_no"] = self.SSEoiService.formatSGAddressUnitFloor(self.editBuyerObj.mailing_address_unit_no_unit, self.editBuyerObj.mailing_address_unit_no_floor);
                }
            }

            if (self.editBuyerObj.mailing_address_same) {
                //Copy primary address to mailing address
                params["mailing_address_line1"] = params["primary_address_line1"];
                params["mailing_address_line2"] = params["primary_address_line2"];
                params["mailing_address_postcode"] = params["primary_address_postcode"];
                params["mailing_address_unit_no"] = params["primary_address_unit_no"];
                params["mailing_address_city"] = params["primary_address_city"];
                params["mailing_address_district"] = params["primary_address_district"];
                params["mailing_address_province"] = params["primary_address_province"];
                params["mailing_address_country"] = params["primary_address_country"];
            }

            if (self.editBuyerObj.individual_dob) {
                self.editBuyerObj.individual_dob = self.SSUtilService.formatDateToStoreWithUtc12(self.editBuyerObj.individual_dob);
            }

            //Check race and relationship
            if (!!self.editBuyerObj.individual_race) {
                if (self.editBuyerObj.individual_race === 'Others') {
                    self.editBuyerObj.individual_race = self.editBuyerObj.individual_race_other;
                }
            }

            if (!!self.editBuyerObj.individual_relationship) {
                if (self.editBuyerObj.individual_relationship === 'Others') {
                    self.editBuyerObj.individual_relationship = self.editBuyerObj.individual_relationship_other;
                }
            }

            if (!!self.editBuyerObj.individual_occupation) {
                if (self.editBuyerObj.individual_occupation == 'OTHERS') {
                    self.editBuyerObj.individual_occupation = self.editBuyerObj.individual_occupation_other;
                }
            }

            if (self.is_add_buyer) {
                self.SSEoiService.addBuyer(params);
                self.updateSecondBuyer(params, 'A new buyer is added successfully.');                
            } else {
                self.updateSecondBuyer(params, 'Buyer information saved successfully.');
            }
        } else {
            self.editBuyerObj.updated_success = false;
        }        
    }

    updateSecondBuyer(buyer, message) {
        const self = this;

        if (self.editBuyerObj.official_address == true) {
            self.SSEoiService.eoi.official_address_buyer_id = buyer.id;
        }

        if (buyer.type == SHOWSUITE.BUYER_TYPE_COMPANY) {
            if (!!self.editIndividualObj.individual_occupation) {
                if (self.editIndividualObj.individual_occupation == 'OTHERS') {
                    self.editIndividualObj.individual_occupation = self.editIndividualObj.individual_occupation_other;
                }
            }

            let params = self.editIndividualObj;
            params["include"] = "individual, company, primary_address, mailing_address, email_contact, phone1_contact, phone2_contact, documents";
            params["type"] = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
            //Address
            params["primary_address_line1"] = self.editBuyerObj.primary_address_line1;
            params["primary_address_line2"] = self.editBuyerObj.primary_address_line2;
            params["primary_address_postcode"] = self.editBuyerObj.primary_address_postcode;
            params["primary_address_unit_no"] = self.editBuyerObj.primary_address_unit_no;
            params["primary_address_city"] = self.editBuyerObj.primary_address_city;
            params["primary_address_district"] = self.editBuyerObj.primary_address_district;
            params["primary_address_province"] = self.editBuyerObj.primary_address_province;
            params["primary_address_country"] = self.editBuyerObj.primary_address_country;

            params["mailing_address_line1"] = self.editBuyerObj.mailing_address_line1;
            params["mailing_address_line2"] = self.editBuyerObj.mailing_address_line2;
            params["mailing_address_postcode"] = self.editBuyerObj.mailing_address_postcode;
            params["mailing_address_unit_no"] = self.editBuyerObj.mailing_address_unit_no;
            params["mailing_address_city"] = self.editBuyerObj.mailing_address_city;
            params["mailing_address_district"] = self.editBuyerObj.mailing_address_district;
            params["mailing_address_province"] = self.editBuyerObj.mailing_address_province;
            params["mailing_address_country"] = self.editBuyerObj.mailing_address_country;

            if (params['individual_identity_type'] == SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                params['individual_national_id'] = null;
            } else {
                params['individual_passport_no'] = null;
            }

            let url = "";

            if (self.is_add_buyer) {
                self.successfullyUpdateBuyer(buyer);
                self.editIndividualObj.updated_success = true;
                self.SSEoiService.addBuyer(self.editIndividualObj);
                self.SSAlertService.success('Success!', message);
            } else {
                self.successfullyUpdateBuyer(buyer);
                self.editIndividualObj.updated_success = true;
                self.SSAlertService.success('Success!', message);
            }            
        } else {
            loading(false);
            self.successfullyUpdateBuyer(buyer);
            self.SSAlertService.success('Success!', message);
        }
    }

    successfullyUpdateBuyer(buyer) {
        const self = this;
        self.editBuyerObj = buyer;
        self.editBuyerObj.updated_success = true;
        self.showEdit = false;
        self.buyerErrors = {};
        self.SSEoiService.hideFooterButtons = false;
        self.is_add_buyer = false;
    }

    validateParticular() {
        const self = this;

        let valid = true;

        self.all_errors = [];

        //Start checking validation
        if (!self.editBuyerObj.type) {
            self.buyerErrors.type = "Please select Type of Buyer";
            self.all_errors.push(self.buyerErrors.type);
            valid = false;
        } else {
            if (self.editBuyerObj.type === SHOWSUITE.BUYER_TYPE_COMPANY) {
                // if (!self.editIndividualObj.individual_title) {
                //     self.buyerIndividualErrors.individual_title = "Please select Salutation";
                //     self.all_errors.push(self.buyerIndividualErrors.individual_title);
                //     valid = false;
                // }

                if (!self.editIndividualObj.individual_legal_name || self.editIndividualObj.individual_legal_name == "" || !self.editIndividualObj.individual_legal_name == null) {
                    self.buyerIndividualErrors.individual_legal_name = "Please enter Name as in NRIC/Passport";
                    self.all_errors.push(self.buyerIndividualErrors.individual_legal_name);
                    valid = false;
                }

                if (!self.editIndividualObj.individual_first_name || self.editIndividualObj.individual_first_name == "" || !self.editIndividualObj.individual_first_name == null) {
                    self.buyerIndividualErrors.individual_first_name = "Please enter First Name of Authorised Officer";
                    self.all_errors.push(self.buyerIndividualErrors.individual_first_name);
                    valid = false;
                }

                if (!self.editIndividualObj.individual_last_name || self.editIndividualObj.individual_last_name == "" || !self.editIndividualObj.individual_last_name == null) {
                    self.buyerIndividualErrors.individual_last_name = "Please enter Last Name of Authorised Officer";
                    self.all_errors.push(self.buyerIndividualErrors.individual_last_name);
                    valid = false;
                }

                // if (self.editIndividualObj.individual_gender == null || self.editIndividualObj.individual_gender == undefined) {
                //     self.buyerIndividualErrors.individual_gender = "Please select Gender";
                //     self.all_errors.push(self.buyerIndividualErrors.individual_gender);
                //     valid = false;
                // }

                if (!self.editIndividualObj.individual_identity_type) {
                    self.buyerIndividualErrors.individual_identity_type = "Please select Identity Type";
                    self.all_errors.push(self.buyerIndividualErrors.individual_identity_type);
                    valid = false;
                } else {
                    if (self.editIndividualObj.individual_identity_type == SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                        if (!self.editIndividualObj.individual_passport_no || self.editIndividualObj.individual_passport_no == "" || self.editIndividualObj.individual_passport_no == null) {
                            self.buyerIndividualErrors.individual_passport_no = "Please enter Passport";
                            self.all_errors.push(self.buyerIndividualErrors.individual_passport_no);
                            valid = false;
                        }
                    } else if (self.editIndividualObj.individual_identity_type != SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                        if (!self.editIndividualObj.individual_national_id || self.editIndividualObj.individual_national_id == "" || self.editIndividualObj.individual_national_id == null) {
                            self.buyerIndividualErrors.individual_national_id = "Please enter NRIC";
                            self.all_errors.push(self.buyerIndividualErrors.individual_national_id);
                            valid = false;
                        }
                    }
                }

                if (!self.editIndividualObj.individual_nationality) {
                    self.buyerIndividualErrors.individual_nationality = "Please select Nationality";
                    self.all_errors.push(self.buyerIndividualErrors.individual_nationality);
                    valid = false;
                }

                // if (!self.editIndividualObj.individual_marital_status) {
                //     self.buyerIndividualErrors.individual_marital_status = "Please select Marital Status";
                //     self.all_errors.push(self.buyerIndividualErrors.individual_marital_status);
                //     valid = false;
                // }

                // if (!self.editIndividualObj.individual_dob || self.editIndividualObj.individual_dob == "" || !self.editIndividualObj.individual_dob == null) {
                //     self.buyerIndividualErrors.individual_dob = "Please enter Date of Birth";
                //     self.all_errors.push(self.buyerIndividualErrors.individual_dob);
                //     valid = false;
                // } else if (moment().diff(moment(self.editIndividualObj.individual_dob, "DD/MM/YYYY")) < 0) {
                //     self.buyerIndividualErrors.individual_dob = "The date of birth cannot be a future date";
                //     self.all_errors.push(self.buyerIndividualErrors.individual_dob);
                //     valid = false;
                // }

                // if (!self.editIndividualObj.email_contact_value || self.editIndividualObj.email_contact_value == "" || !self.editIndividualObj.email_contact_value == null) {
                //     self.buyerIndividualErrors.email_contact_value = "Please enter Email of Authorised Officer";
                //     self.all_errors.push(self.buyerIndividualErrors.email_contact_value);
                //     valid = false;
                // }

                // if (!self.editIndividualObj.phone1_contact_value || self.editIndividualObj.phone1_contact_value == "" || !self.editIndividualObj.phone1_contact_value == null) {
                //     self.buyerIndividualErrors.phone1_contact_value = "Please enter Mobile Number of Authorised Officer";
                //     self.all_errors.push(self.buyerIndividualErrors.phone1_contact_value);
                //     valid = false;
                // }

                if (!self.editBuyerObj.company_name || self.editBuyerObj.company_name == "" || !self.editBuyerObj.company_name == null) {
                    self.buyerErrors.company_name = "Please enter Name of the Company";
                    self.all_errors.push(self.buyerErrors.company_name);
                    valid = false;
                }

                if (!self.editBuyerObj.company_reg_no || self.editBuyerObj.company_reg_no == "" || !self.editBuyerObj.company_reg_no == null) {
                    self.buyerErrors.company_reg_no = "Please enter Company Registration No.";
                    self.all_errors.push(self.buyerErrors.company_reg_no);
                    valid = false;
                }

                if (!self.editBuyerObj.company_nationality) {
                    self.buyerErrors.company_nationality = "Please select Country of Origin";
                    self.all_errors.push(self.buyerErrors.company_nationality);
                    valid = false;
                }

                // if (!self.editBuyerObj.email_contact_value || self.editBuyerObj.email_contact_value == "" || !self.editBuyerObj.email_contact_value == null) {
                //     self.buyerErrors.email_contact_value = "Please enter Company Email";
                //     self.all_errors.push(self.buyerErrors.email_contact_value);
                //     valid = false;
                // }

                // if (!self.editBuyerObj.phone1_contact_value || self.editBuyerObj.phone1_contact_value == "" || !self.editBuyerObj.phone1_contact_value == null) {
                //     self.buyerErrors.phone1_contact_value = "Please enter Company Mobile Number";
                //     self.all_errors.push(self.buyerErrors.phone1_contact_value);
                //     valid = false;
                // }

                if ((self.editingIndex > 0 && !self.editBuyerObj.address_same_first_buyer) || self.editingIndex == 0) {
                    // if (!self.editBuyerObj.primary_address_postcode || self.editBuyerObj.primary_address_postcode == "" || !self.editBuyerObj.primary_address_postcode == null) {
                    //     self.buyerErrors.primary_address_postcode = "Please enter Postal Code";
                    //     self.all_errors.push(self.buyerErrors.primary_address_postcode);
                    //     valid = false;
                    // } else {
                    //     if (self.editBuyerObj.primary_address_country == self.SINGAPORE_SELECTOR_ID && self.editBuyerObj.primary_address_postcode.length != 6) {
                    //         self.buyerErrors.primary_address_postcode = "Please enter Postal Code";
                    //         self.all_errors.push(self.buyerErrors.primary_address_postcode);
                    //         valid = false;
                    //     }
                    // }

                    // if (!self.editBuyerObj.mailing_address_same) {
                    //     if (!self.editBuyerObj.mailing_address_postcode || self.editBuyerObj.mailing_address_postcode == "" || !self.editBuyerObj.mailing_address_postcode == null) {
                    //         self.buyerErrors.mailing_address_postcode = "Please enter Postal Code";
                    //         self.all_errors.push(self.buyerErrors.mailing_address_postcode);
                    //         valid = false;
                    //     } else {
                    //         if (self.editBuyerObj.mailing_address_country == self.SINGAPORE_SELECTOR_ID && self.editBuyerObj.mailing_address_postcode.length != 6) {
                    //             self.buyerErrors.mailing_address_postcode = "Please enter Postal Code";
                    //             self.all_errors.push(self.buyerErrors.mailing_address_postcode);
                    //             valid = false;
                    //         }
                    //     }
                    // }
                }

            } else if (self.editBuyerObj.type === SHOWSUITE.BUYER_TYPE_INDIVIDUAL) {
                // if (!self.editBuyerObj.individual_title) {
                //     self.buyerErrors.individual_title = "Please select Salutation";
                //     self.all_errors.push(self.buyerErrors.individual_title);
                //     valid = false;
                // }

                if (!self.editBuyerObj.individual_legal_name || self.editBuyerObj.individual_legal_name == "" || !self.editBuyerObj.individual_legal_name == null) {
                    self.buyerErrors.individual_legal_name = "Please enter Name as in NRIC/Passport";
                    self.all_errors.push(self.buyerErrors.individual_legal_name);
                    valid = false;
                }

                if (!self.editBuyerObj.individual_first_name || self.editBuyerObj.individual_first_name == "" || !self.editBuyerObj.individual_first_name == null) {
                    self.buyerErrors.individual_first_name = "Please enter First Name of Buyer";
                    self.all_errors.push(self.buyerErrors.individual_first_name);
                    valid = false;
                }

                if (!self.editBuyerObj.individual_last_name || self.editBuyerObj.individual_last_name == "" || !self.editBuyerObj.individual_last_name == null) {
                    self.buyerErrors.individual_last_name = "Please enter Last Name of Buyer";
                    self.all_errors.push(self.buyerErrors.individual_last_name);
                    valid = false;
                }

                // if (self.editBuyerObj.individual_gender == null || self.editBuyerObj.individual_gender == undefined) {
                //     self.buyerErrors.individual_gender = "Please select Gender";
                //     self.all_errors.push(self.buyerErrors.individual_gender);
                //     valid = false;
                // }

                if (!self.editBuyerObj.individual_identity_type) {
                    self.buyerErrors.individual_identity_type = "Please select Identity Type";
                    self.all_errors.push(self.buyerErrors.individual_identity_type);
                    valid = false;
                } else {
                    if (self.editBuyerObj.individual_identity_type == SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                        if (!self.editBuyerObj.individual_passport_no || self.editBuyerObj.individual_passport_no == "" || self.editBuyerObj.individual_passport_no == null) {
                            self.buyerErrors.individual_passport_no = "Please enter Passport";
                            self.all_errors.push(self.buyerErrors.individual_passport_no);
                            valid = false;
                        }
                    } else if (self.editBuyerObj.individual_identity_type != SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                        if (!self.editBuyerObj.individual_national_id || self.editBuyerObj.individual_national_id == "" || self.editBuyerObj.individual_national_id == null) {
                            self.buyerErrors.individual_national_id = "Please enter NRIC";
                            self.all_errors.push(self.buyerErrors.individual_national_id);
                            valid = false;
                        }
                    }
                }

                if (!self.editBuyerObj.individual_nationality) {
                    self.buyerErrors.individual_nationality = "Please select Nationality";
                    self.all_errors.push(self.buyerErrors.individual_nationality);
                    valid = false;
                }

                // if (!self.editBuyerObj.individual_marital_status) {
                //     self.buyerErrors.individual_marital_status = "Please select Marital Status";
                //     self.all_errors.push(self.buyerErrors.individual_marital_status);
                //     valid = false;
                // }

                // if (!self.editBuyerObj.individual_dob || self.editBuyerObj.individual_dob == "" || !self.editBuyerObj.individual_dob == null) {
                //     self.buyerErrors.individual_dob = "Please enter Date of Birth";
                //     self.all_errors.push(self.buyerErrors.individual_dob);
                //     valid = false;
                // } else if (moment().diff(moment(self.editBuyerObj.individual_dob, "DD/MM/YYYY")) < 0) {
                //     self.buyerErrors.individual_dob = "The date of birth cannot be a future date";
                //     self.all_errors.push(self.buyerErrors.individual_dob);
                //     valid = false;
                // }

                // if (!self.editBuyerObj.email_contact_value || self.editBuyerObj.email_contact_value == "" || !self.editBuyerObj.email_contact_value == null) {
                //     self.buyerErrors.email_contact_value = "Please enter Email";
                //     self.all_errors.push(self.buyerErrors.email_contact_value);
                //     valid = false;
                // }

                // if (!self.editBuyerObj.phone1_contact_value || self.editBuyerObj.phone1_contact_value == "" || !self.editBuyerObj.phone1_contact_value == null) {
                //     self.buyerErrors.phone1_contact_value = "Please enter Mobile Number";
                //     self.all_errors.push(self.buyerErrors.phone1_contact_value);
                //     valid = false;
                // }

                if (self.editingIndex > 0) {
                    if (!self.editBuyerObj.individual_relationship) {
                        self.buyerErrors.individual_relationship = "Please select Relationship with Buyer 1";
                        self.all_errors.push(self.buyerErrors.individual_relationship);
                        valid = false;
                    }
                }

                // if ((self.editingIndex > 0 && !self.editBuyerObj.address_same_first_buyer) || self.editingIndex == 0) {
                    // if (!self.editBuyerObj.primary_address_postcode || self.editBuyerObj.primary_address_postcode == "" || !self.editBuyerObj.primary_address_postcode == null) {
                    //     self.buyerErrors.primary_address_postcode = "Please enter Postal Code";
                    //     self.all_errors.push(self.buyerErrors.primary_address_postcode);
                    //     valid = false;
                    // } else {
                    //     if (self.editBuyerObj.primary_address_country == self.SINGAPORE_SELECTOR_ID && self.editBuyerObj.primary_address_postcode.length != 6) {
                    //         self.buyerErrors.primary_address_postcode = "Please enter Postal Code";
                    //         self.all_errors.push(self.buyerErrors.primary_address_postcode);
                    //         valid = false;
                    //     }
                    // }

                    // if (!self.editBuyerObj.mailing_address_same) {
                    //     if (!self.editBuyerObj.mailing_address_postcode || self.editBuyerObj.mailing_address_postcode == "" || !self.editBuyerObj.mailing_address_postcode == null) {
                    //         self.buyerErrors.mailing_address_postcode = "Please enter Postal Code";
                    //         self.all_errors.push(self.buyerErrors.mailing_address_postcode);
                    //         valid = false;
                    //     } else {
                    //         if (self.editBuyerObj.mailing_address_country == self.SINGAPORE_SELECTOR_ID && self.editBuyerObj.mailing_address_postcode.length != 6) {
                    //             self.buyerErrors.mailing_address_postcode = "Please enter Postal Code";
                    //             self.all_errors.push(self.buyerErrors.mailing_address_postcode);
                    //             valid = false;
                    //         }
                    //     }
                    // }
                // }
            }
        }

        if (valid == false) {
            let message = "";
            $.each(self.all_errors, function(index, error) {
                message += "\n" + error;
            });
            self.SSAlertService.danger("Please refer to the following error(s) before proceeding:", message);
        }

        return valid;
    }

    removeParticular(index) {
        const self = this;

        self.remove_buyer_index = index;

        self.hideModals();

        self.showRemoveBuyerModal = true;
        $('#removeBuyerModal').modal('show');
    }

    hideModals() {
        const self = this;

        self.showRemoveBuyerModal = false;

        if ($('#removeBuyerModal').is(':visible')) $('#removeBuyerModal').modal('hide');
    }

    confirmRemoveParticular() {
        const self = this;

        self.SSEoiService.buyers.splice(self.remove_buyer_index, 1);
        self.hideModals();
        self.SSAlertService.success('Success!', 'Buyer successfully removed.');
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }


            field.on("keyup change", function () {
                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));

                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                        //Display error
                        let array = model.split(".");
                        if (array[0] === 'editBuyerObj') {
                            self.buyerErrors[array[1]] = "Invalid Contact No. Please enter the correct contact no.";
                        } else if (array[0] === 'editIndividualObj') {
                            self.buyerIndividualErrors[array[1]] = "Invalid Contact No. Please enter the correct contact no.";
                        }
                    }
                } else {
                    //Remove error
                    let array = model.split(".");
                    if (array[0] === 'editBuyerObj') {
                        self.buyerErrors[array[1]] = "";
                    } else if (array[0] === 'editIndividualObj') {
                        self.buyerIndividualErrors[array[1]] = "";
                    }
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

    updateOccupationSelector() {
        const self = this;
        self.$timeout(function() { 
            $("select.dashboard-select#occupation").niceSelect('update');
            $("select.dashboard-select#occupation_individual").niceSelect('update');
        });
    }

    updateIdentityType(buyer) {
        const self = this;

        if (buyer.individual_identity_type == SHOWSUITE.IDENTITY_TYPE_SINGAPOREAN) {
            buyer.individual_nationality = self.SSEoiService.nationalities.find(x => x.name == 'Singaporean').id;
            self.$timeout(function() { 
                $("select.dashboard-select#individual_nationality").niceSelect('update');
                $("select.dashboard-select#company_nationality").niceSelect('update');
            });
        } else {
            if (buyer.individual_nationality) {
                buyer.individual_nationality = "";
                self.$timeout(function() { 
                    $("select.dashboard-select#individual_nationality").niceSelect('update');
                    $("select.dashboard-select#company_nationality").niceSelect('update');
                });
            }
        }
    }

    searchAddress(address_type) {
        const self = this;

        self.buyerErrors[address_type + "_postcode"] = null;

        if (!(address_type === self.primary_address_type || address_type === self.mailing_address_type)) {
            console.log("Error! Invalid address type " + address_type);
            return;
        }

        if (!self.editBuyerObj[address_type + "_postcode"] || self.editBuyerObj[address_type + "_postcode"] == "" || self.editBuyerObj[address_type + "_postcode"] == null) {
            self.buyerErrors[address_type + "_postcode"] = "Please enter postal code to search";
            return;
        } else {
            if (self.editBuyerObj[address_type + "_postcode"].length != 6) {
                self.buyerErrors[address_type + "_postcode"] = "Please enter the correct postal code format to search";
                return;
            }
        }

        // WEB-4652: via the Showsuite API — OneMap now needs a server-held token.
        self.SSHttpService.getAddressFromPostcode(self.editBuyerObj[address_type + "_postcode"], function (result, errorMessage) {
            self.$timeout(function() {
                if (errorMessage) {
                    self.buyerErrors[address_type + "_postcode"] = errorMessage;
                } else if (result) {
                    //Update address
                    self.editBuyerObj[address_type + "_line1"] = result.BLK_NO;
                    if (result.BUILDING === "NIL" || result.BUILDING === "") {
                        self.editBuyerObj[address_type + "_line2"] = result.ROAD_NAME;
                    } else {
                        self.editBuyerObj[address_type + "_line2"] = result.ROAD_NAME + ", " + result.BUILDING;
                    }
                    
                    self.editBuyerObj[address_type + "_district"] = "";
                    self.editBuyerObj[address_type + "_city"] = "Singapore";
                } else {
                    self.buyerErrors[address_type + "_postcode"] = "Invalid postcode, please try again.";
                }
            });
        }, false);
    }

    onBookingProceed() {
        const self = this;

        //Check has buyer or not
        if (self.SSEoiService.buyers && self.SSEoiService.buyers.length > 0) {
            let url = '';
            let params = {};
            let counter = 0;

            loading(true);
            $.each(self.SSEoiService.buyers, function(index, buyer) {
                //Modified buyer's objects
                let temp_buyer = angular.copy(buyer);

                if (temp_buyer.type === SHOWSUITE.BUYER_TYPE_COMPANY) {
                    temp_buyer["company"] = {
                        "name": temp_buyer.company_name,
                        "reg_no": temp_buyer.company_reg_no,
                    };
                    temp_buyer["individual"] = null;
                } else {
                    temp_buyer["individual"] = {
                        "title": temp_buyer.individual_title,
                        "first_name": temp_buyer.individual_first_name,
                        "last_name": temp_buyer.individual_last_name,
                        "display_name": temp_buyer.individual_display_name,
                        "legal_name": temp_buyer.individual_legal_name,
                        "gender": temp_buyer.individual_gender,
                        "marital_status": temp_buyer.individual_marital_status,
                        "dob": temp_buyer.individual_dob,
                        "identity_type": temp_buyer.individual_identity_type,
                        "nationality": temp_buyer.individual_nationality,
                        "national_id": temp_buyer.individual_national_id,
                        "passport_no": temp_buyer.individual_passport_no,
                        "industry": temp_buyer.individual_industry,
                        "occupation": temp_buyer.individual_occupation,
                        "race": temp_buyer.individual_race,
                        "race_other": temp_buyer.individual_race_other,
                        "relationship": temp_buyer.individual_relationship,
                        "relationship_other": temp_buyer.individual_relationship_other
                    };
                    temp_buyer["company"] = null;
                }

                temp_buyer["email_contact"] = {
                    "type": 1,
                    "value": temp_buyer.email_contact_value,
                    "verified": 0,
                };

                temp_buyer["phone1_contact"] = {
                    "type": 2,
                    "value": temp_buyer.phone1_contact_value,
                    "verified": 0,
                };

                temp_buyer["phone2_contact"] = {
                    "type": 2,
                    "value": temp_buyer.phone2_contact_value,
                    "verified": 0,
                };

                temp_buyer["lawyers"] = {};                

                temp_buyer["primary_address"] = {
                    "line1":temp_buyer.primary_address_line1,
                    "line2":temp_buyer.primary_address_line2,
                    "postcode":temp_buyer.primary_address_postcode,
                    "unit_no":temp_buyer.primary_address_unit_no,
                    "city":temp_buyer.primary_address_city,
                    "district":temp_buyer.primary_address_district,
                    "province":null,
                    "country":temp_buyer.primary_address_country
                };

                temp_buyer["mailing_address"] = {
                    "line1":temp_buyer.mailing_address_line1,
                    "line2":temp_buyer.mailing_address_line2,
                    "postcode":temp_buyer.mailing_address_postcode,
                    "unit_no":temp_buyer.mailing_address_unit_no,
                    "city":temp_buyer.mailing_address_city,
                    "district":temp_buyer.mailing_address_district,
                    "province":null,
                    "country":temp_buyer.mailing_address_country
                };

                params = {
                    'data': JSON.stringify(temp_buyer),
                    'order': index + 1
                };

                if (!!buyer.saleBuyerId) {
                    url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/buyers/' + buyer.saleBuyerId;
                    self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                        if (response instanceof Error) {
                            loading(false);
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }
                        buyer.saleBuyerId = response.data.sale_buyer.id;
                        counter++;
                        if (counter == self.SSEoiService.buyers.length) {
                            self.proceedDiscountsPage();
                        }
                        
                    });
                } else {
                    url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/buyers';
                    self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                        if (response instanceof Error) {
                            loading(false);
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }
                        buyer.saleBuyerId = response.data.sale_buyer.id;
                        counter++;
                        if (counter == self.SSEoiService.buyers.length) {
                            self.proceedDiscountsPage();
                        }
                    });
                }
                
            });

        } else {
            self.SSAlertService.danger('Error!', "Please add at least 1 buyer to proceed.");
            return;
        }
    }

    proceedDiscountsPage() {
        loading(false);
        const self = this;

        self.SSAlertService.message = null;

        // Apply standard discount by default
        try{
            let standard_discounts = self.SSSaleDiscountsService.getStandardDiscounts(self.SSEoiService.all_property_discounts);
            if(standard_discounts && standard_discounts.length && self.SSEoiService.sale_obj.selected_units.length > 0 
                && !self.SSEoiService.sale_obj.selected_units[0].is_standard_discount_applied){
                
                self.applyStandardDiscounts(standard_discounts);
            }
            else{
                // Launch 'Add Discount' page
                self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_ADD_DISCOUNTS_PAGE;
            }
        }
        catch(ex){
           loading(false);
           console.log(ex); 
        }
    }

    applyStandardDiscounts(standardPropertyDiscounts) {
        const self = this;

        if (!(self.SSEoiService.sale_obj && self.SSEoiService.sale_obj.selected_units[0] && standardPropertyDiscounts)) return; // Skip, missing data

        if (!(standardPropertyDiscounts)) return; // Skip as no data

        let propertyDiscountsToApply = [];

        let sale_unit = self.SSEoiService.sale_obj.selected_units[0];

        $.each(standardPropertyDiscounts, function (index, propertyDiscount) {

            if (propertyDiscount.marketing_scheme
                && propertyDiscount.marketing_scheme !== self.selectedEoi.marketing_scheme
            ) {
                return; // Skip. This will only apply to assigned Marketing Scheme
            }

            if (!(self.SSSaleDiscountsService.isDiscountApplicable(sale_unit.id, propertyDiscount))) {
                return; // Skip. This will only apply to assigned units
            }

            if (!sale_unit.hasOwnProperty("applied_discounts") || !sale_unit.applied_discounts) {
                sale_unit.applied_discounts = []; // Initialize
            }

            let appliedDiscount = sale_unit.applied_discounts.find(x => x.property_discount_id === propertyDiscount.id);

            if (!appliedDiscount) {
                propertyDiscountsToApply.push({
                    eoi_unit: sale_unit,
                    property_discount: propertyDiscount
                });
            }
        });

        self.APPLY_DISCOUNTS_COUNTER = 0;
        self.TOTAL_DISCOUNTS_TO_APPLY = propertyDiscountsToApply.length;

        self.propertyDiscountsToApply = propertyDiscountsToApply;

        self.applyDiscounts();
    }

    applyDiscounts(){
        const self = this;

        let obj = self.propertyDiscountsToApply[self.APPLY_DISCOUNTS_COUNTER];

        self.$scope.$$nextSibling.discountCtrl.selected_unit_discount = obj.eoi_unit;
        self.$scope.$$nextSibling.discountCtrl.add_discount = obj.property_discount;

        // Apply Discount
        self.$scope.$$nextSibling.discountCtrl.onAddDiscount(obj.property_discount, obj.eoi_unit, function(response){
            self.APPLY_DISCOUNTS_COUNTER++;

            if(self.APPLY_DISCOUNTS_COUNTER < self.TOTAL_DISCOUNTS_TO_APPLY) self.applyDiscounts();
            else {
                loading(false);
                self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_ADD_DISCOUNTS_PAGE;
            }
             
        });
    }

    moveUp(buyer) {
        const self = this;

        let index = self.SSEoiService.buyers.findIndex(x => x.$$hashKey == buyer.$$hashKey);
        if (index > 0) {
            let el = self.SSEoiService.buyers[index];
            self.SSEoiService.buyers[index] = self.SSEoiService.buyers[index - 1];
            self.SSEoiService.buyers[index - 1] = el;
        }
    }

    moveDown(buyer) {
        const self = this;

        let index = self.SSEoiService.buyers.findIndex(x => x.$$hashKey == buyer.$$hashKey);
            if (index !== -1 && index < self.SSEoiService.buyers.length - 1) {
            let el = self.SSEoiService.buyers[index];
            self.SSEoiService.buyers[index] = self.SSEoiService.buyers[index + 1];
            self.SSEoiService.buyers[index + 1] = el;
        }
    }
}

SalesApplicationAddSaleBuyerParticularController.$inject = ['$scope', '$sce', '$parse', '$timeout', 'SSHttpService', 'SSEoiService', 'SSUserService', 'SSConfigService', 'SSUtilService', 'SSAlertService', 'SSAwsService', 'SSSaleDiscountsService'];
app.controller('SalesApplicationAddSaleBuyerParticularController', SalesApplicationAddSaleBuyerParticularController);